import { useState, useEffect } from 'react';
import { X, AlertTriangle, Tag } from 'lucide-react';

export default function NotificacaoNomeProdutoInvalido({ notificacao, onClose }) {
  const [tempoRestante, setTempoRestante] = useState(60);
  const d = notificacao.dados;

  useEffect(() => {
    const t = setInterval(() => {
      setTempoRestante(prev => {
        if (prev <= 1) { clearInterval(t); onClose(); return 0; }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(t);
  }, [onClose]);

  const funcionarioNome = d.funcionario
    ? d.funcionario.replace(/^\d+ - /, '')
    : '—';

  return (
    <div className="w-96 bg-white rounded-xl shadow-2xl border-2 border-red-400 overflow-hidden animate-slide-in">
      {/* Header */}
      <div className="bg-gradient-to-r from-red-500 to-orange-500 px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center flex-shrink-0">
            <AlertTriangle className="w-6 h-6 text-red-500" />
          </div>
          <div className="text-white">
            <h3 className="font-bold text-base leading-tight">Nome de Produto Inválido!</h3>
            <p className="text-xs opacity-80">Fora do padrão de nomenclatura</p>
          </div>
        </div>
        <button onClick={onClose} className="text-white hover:bg-white/20 rounded-lg p-1.5 transition-colors">
          <X className="w-5 h-5" />
        </button>
      </div>

      {/* Conteúdo */}
      <div className="p-4 space-y-3">
        {/* Produto */}
        <div className="bg-red-50 rounded-lg p-3 border border-red-200">
          <div className="flex items-center gap-2 text-red-700 text-xs mb-1">
            <Tag className="w-3.5 h-3.5" />
            Produto
          </div>
          <p className="font-bold text-gray-900 text-2xl">Cód. {d.codigo_produto}</p>
          {d.nome_produto && (
            <p className="text-xs text-gray-600 mt-1 break-words">{d.nome_produto}</p>
          )}
          {d.funcionario && (
            <p className="text-xs text-gray-500 mt-1">Operador: {funcionarioNome}</p>
          )}
        </div>

        {/* Motivo / Sugestão */}
        {d.motivo && (
          <div className="bg-red-50 border border-red-200 rounded-lg px-3 py-2">
            <p className="text-xs font-semibold text-gray-800 mb-0.5">Motivo:</p>
            <p className="text-xs text-gray-700">{d.motivo}</p>
          </div>
        )}
        {d.nome_sugerido && (
          <div className="bg-green-50 border border-green-200 rounded-lg px-3 py-2">
            <p className="text-xs font-semibold text-gray-800 mb-0.5">Sugestão:</p>
            <p className="text-xs text-gray-700 break-words">{d.nome_sugerido}</p>
          </div>
        )}

        {/* Barra de progresso */}
        <div className="w-full bg-gray-100 rounded-full h-1.5">
          <div
            className="bg-red-400 h-1.5 rounded-full transition-all duration-1000 ease-linear"
            style={{ width: `${(tempoRestante / 60) * 100}%` }}
          />
        </div>
        <p className="text-xs text-gray-400 text-center">Fechará em {tempoRestante}s</p>
      </div>
    </div>
  );
}
